import { render, staticRenderFns } from "./virkailijat.vue?vue&type=template&id=04596d13&"
import script from "./virkailijat.vue?vue&type=script&lang=ts&"
export * from "./virkailijat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports